/* eslint-disable */
import type { RawLocation } from 'vue-router';
import VueRouter from 'vue-router';

const originalPush = VueRouter.prototype.push;

VueRouter.prototype.push = async function push(
  location: RawLocation
): Promise<any> {
  try {
    return await originalPush.call(this, location);
  } catch (error) {
    // Avoid NavigationDuplicated error
    if (VueRouter.isNavigationFailure(error)) {
      // Devour the "error" silently
    } else {
      return Promise.reject(error);
    }
  }
};

export { VueRouter as VueRouterOverride };
